<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">
            
    </base-header>
    <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">Tenant</h3>
                  </div>
                </div>
              </div>
              <template>
              <form>
                <h6 class="heading-small text-muted mb-4">Tenant information</h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input alternative=""
                          label="Họ Tên"
                          placeholder="Họ Và Tên"
                          input-classes="form-control-alternative"
                          v-model="tenant.name"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input alternative=""
                          label="Số Căn Cước"
                          placeholder="Số Căn Cước"
                          input-classes="form-control-alternative"
                          v-model="tenant.nationalid"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input alternative=""
                          label="Passport ID"
                          placeholder="Passport ID"
                          input-classes="form-control-alternative"
                          v-model="tenant.passportid"
                        />
                      </div>
                      <div class="col-lg-6">
                        <textarea class="form-control" id="FormControlTextarea1" rows="3" placeholder="Ghi chú ..." v-model="tenant.notes"></textarea>
                      </div>
                    </div>
                     <div class="row">
                          <div class="col-lg-6">
                            <slot>Từ Ngày</slot>
                            <base-input addon-left-icon="ni ni-calendar-grid-58">
                              <flat-pickr slot-scope="{focus, blur}"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{allowInput: true}"
                              class="form-control datepicker"
                              v-model="tenant.beginDate">
                              </flat-pickr>
                            </base-input>
                          </div>
                          <div class="col-lg-6">
                            <slot>Đến Ngày</slot>
                            <base-input addon-left-icon="ni ni-calendar-grid-58">
                              <flat-pickr slot-scope="{focus, blur}"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{allowInput: true}"
                              class="form-control datepicker"
                              v-model="tenant.endDate">
                              </flat-pickr>
                            </base-input>
                          </div>
                        </div>
                  </div>
                    <hr class="my-4" />
                      <!-- Address -->
                      <h6 class="heading-small text-muted mb-4">Contact information</h6>
                      <div class="pl-lg-4">
                        <div class="row">
                          <div class="col-md-12">
                            <base-input alternative=""
                              label="Địa Chỉ"
                              placeholder="Địa Chỉ Liên Hệ"
                              input-classes="form-control-alternative"
                              v-model="tenant.address"
                            />
                          </div>
                        </div>
                       <div class="row">
                         <div class="col-lg-6">
                           <base-input alternative=""
                             label="Email"
                             placeholder="Email"
                             input-classes="form-control-alternative"
                             v-model="tenant.email"
                           />
                         </div>
                         <div class="col-lg-6">
                           <base-input alternative=""
                             label="Mobile"
                             placeholder="Mobile"
                             input-classes="form-control-alternative"
                             v-model="tenant.mobile"
                           />
                         </div>
                        </div>
                       
                      </div>
                      <hr class="my-4" />
                      <div class="col text-right">
                        <base-button type="primary" class="my-4" @click="createTenant">Create</base-button> 
                      </div>
                      </form>
              </template>
    </card>
  </div>
</template>
<script>
export default {
  data() {
    return {
        tenant: {
          name: '',
          passportid: '',
          nationalid: '',
          mobile: '',
          address: '',
          status: true,
          beginDate: null,
          endDate: null

        },
        err: ''
    }
  },
  mounted() {
  },
  methods: {
    createTenant() {
      this.$http.post('/tenants/add', this.tenant).then(() => {
        this.$router.push('/tenants')
      }).catch((err) => {
        this.$notify({type: 'warning', message: err});
        this.$router.push('/tenants/create')
      })
    }
  },
  components: {

    }
  
}
</script>
<style>

</style>